<template>
  <!-- height:100% 传递 .pad 高度给子路由页，否则页面内 height:100%/flex:1 全部退化为内容高 -->
  <div style="height:100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "SuperPage"
}
</script>

<style scoped>

</style>